import React, { useEffect, useState } from 'react'
import SideBar from '../Components/SideBar';
import Header from '../Components/Header';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Add_Productlist, selectProductlist } from '../Redux/Slice/ProductList';
import { Add_Client, selectClient } from '../Redux/Slice/ClientsDetails';
import { Add_Bed, selectBed } from '../Redux/Slice/BedAllocation';
import { Add_Deceased, selectDeceased } from '../Redux/Slice/DeceasedDetails';
import axios from 'axios';
import BASEURL from '../Connection/BASEURL';
import { Button, Paper, TextField, Step, StepLabel, Stepper } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { Add_Payment, selectPayment } from '../Redux/Slice/Payment';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const DeceasedInvoice = () => {
    const navigate = useNavigate();
    const productData = useSelector(selectProductlist);
    const ClientData = useSelector(selectClient);
    const paymentamount = useSelector(selectPayment);
    const BedData = useSelector(selectBed);
    const DeceasedData = useSelector(selectDeceased);
    const [Get_Open_closing, setGet_Open_closing] = useState("");
    const [refreshData, setrefreshData] = useState(false);
    const [discountPercentage, setDiscountPercentage] = useState(0);
    const [discountAmountState, setDiscountAmountState] = useState(0);
    const dispatch = useDispatch();
    const location = useLocation();


    const [bed, setbed] = useState("");
    const [field, setfield] = useState("");
    const [letter, setletter] = useState("");
    const [number, setnumber] = useState("");
    const [loading4, setloading4] = useState(false);



    function printDiv() {
        window.print();
    }


    const fetchDiscount = async () => {
        try {
            const response = await axios.get(`${BASEURL}/discounts`);
            const discounts = response.data;
            if (discounts && discounts.length > 0) {
                setDiscountPercentage(discounts[0].discount_amount || 0);
            }
        } catch (error) {
            console.log('Error fetching discount:', error);
        }
    };

    useEffect(() => {
        fetchDiscount();
    }, []);

    useEffect(() => {
        axios.get(`${BASEURL}/clients/deceased_data/${location?.state?.id}`).then((response) => {
            const data = response.data;
            console.log("new", data);
            setrefreshData(true);
            dispatch(Add_Client({
                fname: data.fname,
                lname: data.lname,
                daddress: data.daddress,
                phone: data.phone
            }))
        }).catch((err) => {
            console.log(err);
        })
    }, []);

    const [Get_D, setGet_Deceased] = useState({})


    useEffect(() => {
        axios.get(`${BASEURL}/deceased/${location?.state?.id}`).then((response) => {
            const data = response.data;
            console.log(data);
            setGet_Deceased(data);
            setrefreshData(true);
            // dispatch(Add_Client({
            //     fname: data.fname,
            //     lname: data.lname,
            //     daddress: data.daddress,
            //     phone: data.phone
            // }))
            dispatch(Add_Productlist({
                sale_of_grave: data.sale_of_grave,
                open_and_closing: data.open_and_closing
            }));

            dispatch(Add_Payment({
                payment: data.payment_amount
            }))

            dispatch(Add_Bed({
                bedname: data?.bed
            }));

            dispatch(Add_Deceased({
                fname: data?.fname,
                lname: data?.lname,
                dod: data?.dod,
                aged: data?.Aged,
                dobrial: data?.dobrial
            }))

        }).catch((err) => {
            console.log(err);
        })
    }, []);



    useEffect(() => {
        axios.get(`${BASEURL}/deceased/${location.state.id}`).then((response) => {
            const data = response.data;
            setGet_Deceased(data);
        })
    }, [])







    useEffect(() => {
        axios.get(`${BASEURL}/onc/1/${productData?.open_and_closing}`).then((response) => {
            const data = response.data;
            setGet_Open_closing(data);
        }).catch((err) => {
            console.log(err);
        })
    }, [refreshData])




    const [Get_All_Fees, setGet_All_Fees] = useState("");
    const [editMode, setEditMode] = useState(false);
    const [activeStep, setActiveStep] = useState(0);
    const steps = ["Invoice Receipt", "Interment Cert"];
    const [priceSaleOfGrave, setPriceSaleOfGrave] = useState("");
    const [qty, setQty] = useState(1);
    const [invoiceDate, setInvoiceDate] = useState(dayjs());
    const [quoteNo, setQuoteNo] = useState("");
    const [receiptNo, setReceiptNo] = useState("");
    const [customerName, setCustomerName] = useState("");
    const [customerAddress, setCustomerAddress] = useState("");
    const [customerPhone, setCustomerPhone] = useState("");
    const [productLabel, setProductLabel] = useState("");
    const [intermentDate, setIntermentDate] = useState(null);
    const [bedName, setBedName] = useState("");
    const [deceasedName, setDeceasedName] = useState("");
    const [paymentMethod, setPaymentMethod] = useState("CHEQUE");
    const [paymentDate, setPaymentDate] = useState(dayjs());

    useEffect(() => {
        const Get_One = () => {
            axios.get(`${BASEURL}/fee/1/${productData?.sale_of_grave}`).then((response) => {
                const data = response.data;
                setGet_All_Fees(data)
                if (!priceSaleOfGrave) setPriceSaleOfGrave(data);
            }).catch((err) => {
                console.log(err);
            })
        }
        Get_One()
    }, [refreshData])


    const [Get_Lowering_Device, setGet_Lowering_Device] = useState({})

    useEffect(() => {
        axios.get(`${BASEURL}/fee/1`).then((response) => {
            const data = response.data;
            setGet_Lowering_Device(data);
        }).catch((err) => {
            console.log(err);
        })
    }, [refreshData]);

    function getCurrentDate() {
        const options = { day: 'numeric', month: 'long', year: 'numeric' };
        const currentDate = new Date().toLocaleDateString(undefined, options);
        return currentDate;
    }

    // Call the function to get the current date in the desired format
    const formattedDate = getCurrentDate();


    function generateRandom5DigitNumber() {
        const min = 10000; // Minimum 5-digit number
        const max = 99999; // Maximum 5-digit number
        const random5DigitNumber = Math.floor(Math.random() * (max - min + 1)) + min;
        return random5DigitNumber;
    }

    // Call the function to get a random 5-digit number
    const random5DigitNumber = generateRandom5DigitNumber();




    // const handleNext = () => {
    //     setActiveStep((prevActiveStep) => prevActiveStep + 1);
    // };

    // const handleBack = () => {
    //     setActiveStep((prevActiveStep) => prevActiveStep - 1);
    // };

    const [loading1, setloading1] = useState(false);
    const [loading2, setloading2] = useState(false);


    function printDiv() {
        // dispatch(Clear_Productlist());
        // dispatch(Clear_Client());
        window.print();

    }

    const [gettax, settax] = useState("");
    const [vatPctEdit, setVatPctEdit] = useState("");

    useEffect(() => {
        axios.get(`${BASEURL}/tax/1/vat`).then((response) => {
            const data = response.data;
            settax(data);
        }).catch((err) => {
            console.lo(err);
        });

    }, []);

    const [getnhil, setgetnhil] = useState("");
    const [nhilPctEdit, setNhilPctEdit] = useState("");

    useEffect(() => {
        axios.get(`${BASEURL}/tax/1/nhil_levy`).then((response) => {
            const data = response.data;
            setgetnhil(data);
        }).catch((err) => {
            console.lo(err);
        });

    }, []);



    // Initialize editable values when data loads
    useEffect(() => {
        if (Get_All_Fees && priceSaleOfGrave === "") {
            setPriceSaleOfGrave(Get_All_Fees);
        }
    }, [Get_All_Fees]);

    useEffect(() => {
        if (gettax !== "" && vatPctEdit === "") {
            setVatPctEdit(gettax);
        }
    }, [gettax]);

    useEffect(() => {
        if (getnhil !== "" && nhilPctEdit === "") {
            setNhilPctEdit(getnhil);
        }
    }, [getnhil]);

    const effectiveSalePrice = parseFloat(priceSaleOfGrave || 0) * parseFloat(qty || 1);
    const effectiveNhilPct = parseFloat(nhilPctEdit === "" ? 0 : nhilPctEdit);
    const effectiveVatPct = parseFloat(vatPctEdit === "" ? 0 : vatPctEdit);

    const percentage_NHIL_SALE_OF_GARVE = effectiveNhilPct;
    const amount_NHIL_SALE_OF_GARVE = effectiveSalePrice;
    const result_amount_NHIL_SALE_OF_GARVE = ((percentage_NHIL_SALE_OF_GARVE / 100) * amount_NHIL_SALE_OF_GARVE)

    // const AmountLeft = parseFloat(Total_VAT_CALCULATION) + parseFloat(Subtotal_Calculation) + parseFloat(Toal_NHIL_GETFUND) - parseFloat(paymentamount?.payment);
    const Total_Combination_of_Tax1 = parseFloat(effectiveSalePrice) + parseFloat(result_amount_NHIL_SALE_OF_GARVE);



    // Vat Calculation for sale_of_grace
    const percentageSALE_OF_GARVE = effectiveVatPct;
    const amountSALE_OF_GARVE = effectiveSalePrice;
    const resultSALE_OF_GARVE = ((percentageSALE_OF_GARVE / 100) * Total_Combination_of_Tax1)
    console.log(resultSALE_OF_GARVE); // Output: 131.3





    const TOTAL_NHILGETFUND = parseFloat(result_amount_NHIL_SALE_OF_GARVE);
    const TOTAL_TAX = parseFloat(resultSALE_OF_GARVE);
    const Ext_PriceTotal = parseFloat(effectiveSalePrice);
    const GRAND_TOTAL_BEFORE_DISCOUNT = parseFloat(Total_Combination_of_Tax1) + parseFloat(resultSALE_OF_GARVE);
    
    // Calculate discount amount and final total
    const calculatedDiscountAmount = (discountPercentage / 100) * GRAND_TOTAL_BEFORE_DISCOUNT;
    const GRAND_TOTAL = GRAND_TOTAL_BEFORE_DISCOUNT - calculatedDiscountAmount;
    
    const [paymentEdited, setPaymentEdited] = useState("");
    useEffect(() => {
        if (paymentamount?.payment && paymentEdited === "") {
            setPaymentEdited(paymentamount?.payment);
        }
    }, [paymentamount]);

    // Editable invoice values
    const [vatAmountEdited, setVatAmountEdited] = useState("");
    const [extPriceTotalEdited, setExtPriceTotalEdited] = useState("");
    const [nhilAmountEdited, setNhilAmountEdited] = useState("");
    const [subtotalEdited, setSubtotalEdited] = useState("");
    const [discountAmountEdited, setDiscountAmountEdited] = useState("");
    const [totalEdited, setTotalEdited] = useState("");

    // Track if values have been manually edited
    const [hasBeenEdited, setHasBeenEdited] = useState({
        vat: false,
        extPrice: false,
        nhil: false,
        subtotal: false,
        discount: false,
        total: false
    });

    // Initialize editable values with calculated values (only if not manually edited)
    useEffect(() => {
        if (!isNaN(resultSALE_OF_GARVE) && resultSALE_OF_GARVE !== null && !hasBeenEdited.vat) {
            setVatAmountEdited(String(resultSALE_OF_GARVE.toFixed(2)));
        }
    }, [resultSALE_OF_GARVE, hasBeenEdited.vat]);

    useEffect(() => {
        if (!isNaN(Ext_PriceTotal) && Ext_PriceTotal !== null && !hasBeenEdited.extPrice) {
            setExtPriceTotalEdited(String(Ext_PriceTotal.toFixed(2)));
        }
    }, [Ext_PriceTotal, hasBeenEdited.extPrice]);

    useEffect(() => {
        if (!isNaN(result_amount_NHIL_SALE_OF_GARVE) && result_amount_NHIL_SALE_OF_GARVE !== null && !hasBeenEdited.nhil) {
            setNhilAmountEdited(String(result_amount_NHIL_SALE_OF_GARVE.toFixed(2)));
        }
    }, [result_amount_NHIL_SALE_OF_GARVE, hasBeenEdited.nhil]);

    useEffect(() => {
        if (!isNaN(GRAND_TOTAL_BEFORE_DISCOUNT) && GRAND_TOTAL_BEFORE_DISCOUNT !== null && !hasBeenEdited.subtotal) {
            setSubtotalEdited(String(GRAND_TOTAL_BEFORE_DISCOUNT.toFixed(2)));
        }
    }, [GRAND_TOTAL_BEFORE_DISCOUNT, hasBeenEdited.subtotal]);

    useEffect(() => {
        if (!isNaN(calculatedDiscountAmount) && calculatedDiscountAmount !== null && !hasBeenEdited.discount) {
            setDiscountAmountEdited(String(calculatedDiscountAmount.toFixed(2)));
        }
    }, [calculatedDiscountAmount, hasBeenEdited.discount]);

    useEffect(() => {
        if (!isNaN(GRAND_TOTAL) && GRAND_TOTAL !== null && !hasBeenEdited.total) {
            setTotalEdited(String(GRAND_TOTAL.toFixed(2)));
        }
    }, [GRAND_TOTAL, hasBeenEdited.total]);

    // Use edited values if they exist and are valid, otherwise use calculated values
    const effectiveVatAmount = (vatAmountEdited !== "" && vatAmountEdited !== null && !isNaN(parseFloat(vatAmountEdited))) 
        ? parseFloat(vatAmountEdited) 
        : (resultSALE_OF_GARVE || 0);
    const effectiveExtPriceTotal = (extPriceTotalEdited !== "" && extPriceTotalEdited !== null && !isNaN(parseFloat(extPriceTotalEdited))) 
        ? parseFloat(extPriceTotalEdited) 
        : (Ext_PriceTotal || 0);
    const effectiveNhilAmount = (nhilAmountEdited !== "" && nhilAmountEdited !== null && !isNaN(parseFloat(nhilAmountEdited))) 
        ? parseFloat(nhilAmountEdited) 
        : (result_amount_NHIL_SALE_OF_GARVE || 0);
    const effectiveSubtotal = (subtotalEdited !== "" && subtotalEdited !== null && !isNaN(parseFloat(subtotalEdited))) 
        ? parseFloat(subtotalEdited) 
        : (GRAND_TOTAL_BEFORE_DISCOUNT || 0);
    const effectiveDiscountAmount = (discountAmountEdited !== "" && discountAmountEdited !== null && !isNaN(parseFloat(discountAmountEdited))) 
        ? parseFloat(discountAmountEdited) 
        : (calculatedDiscountAmount || 0);
    const effectiveTotal = (totalEdited !== "" && totalEdited !== null && !isNaN(parseFloat(totalEdited))) 
        ? parseFloat(totalEdited) 
        : (GRAND_TOTAL || 0);

    const AmountLeft = parseFloat(effectiveSubtotal) - parseFloat(paymentEdited || 0);

    // Reset all edited values back to calculated values
    const resetToCalculated = () => {
        setVatAmountEdited(String((resultSALE_OF_GARVE || 0).toFixed(2)));
        setExtPriceTotalEdited(String((Ext_PriceTotal || 0).toFixed(2)));
        setNhilAmountEdited(String((result_amount_NHIL_SALE_OF_GARVE || 0).toFixed(2)));
        setSubtotalEdited(String((GRAND_TOTAL_BEFORE_DISCOUNT || 0).toFixed(2)));
        setDiscountAmountEdited(String((calculatedDiscountAmount || 0).toFixed(2)));
        setTotalEdited(String((GRAND_TOTAL || 0).toFixed(2)));
        setHasBeenEdited({
            vat: false,
            extPrice: false,
            nhil: false,
            subtotal: false,
            discount: false,
            total: false
        });
    };

    return (
        <div className=' grid grid-cols-12'>
            <div className=' col-span-2'>
                <SideBar />
            </div>
            <div className=' col-span-12 lg:col-span-10 bg-[#D2D2CF]'>
                <Header />
                <div className=' mx-8 my-6'>
                    <div className=" flex items-center justify-between mt-3">
                        <h1 className=" text-4xl font-bold  text-[#111927] py-2">
                            New Invoice
                        </h1>
                        <div className=' flex items-center space-x-2'>
                            <Button onClick={() => setEditMode(!editMode)} variant="outlined" style={{ borderColor: "#083050", color: "#083050" }}>{editMode ? 'Done' : 'Edit'}</Button>
                            <Button onClick={printDiv} variant="contained" style={{ backgroundColor: "#083050", color: "white" }}>Print Reciept</Button>
                        </div>
                    </div>

                    {editMode && (
                        <Paper elevation={1} className=' bg-white mt-4 p-4' style={{ borderRadius: 12 }}>
                            <div className=' flex justify-end mb-4'>
                                <Button 
                                    onClick={resetToCalculated} 
                                    variant="outlined" 
                                    style={{ borderColor: "#22C55E", color: "#22C55E" }}
                                >
                                    Reset to Calculated Values
                                </Button>
                            </div>
                            <div className=' grid grid-cols-1 md:grid-cols-4 gap-4'>
                                <TextField
                                    label='Quote #'
                                    value={quoteNo || `Q00${random5DigitNumber}`}
                                    onChange={(e) => setQuoteNo(e.target.value)}
                                    fullWidth
                                />
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label='Quote Date'
                                        value={invoiceDate}
                                        onChange={(d) => setInvoiceDate(d)}
                                        renderInput={(params) => <TextField fullWidth {...params} />}
                                    />
                                </LocalizationProvider>
                                <TextField
                                    label='Customer Name'
                                    value={customerName || `${ClientData?.fname || ''} ${ClientData?.lname || ''}`}
                                    onChange={(e) => setCustomerName(e.target.value)}
                                    fullWidth
                                />
                                <TextField
                                    label='Customer Address'
                                    value={customerAddress || ClientData?.daddress || ''}
                                    onChange={(e) => setCustomerAddress(e.target.value)}
                                    fullWidth
                                />
                                <TextField
                                    label='Customer Phone'
                                    value={customerPhone || (ClientData?.phone ? `0${ClientData?.phone}` : '')}
                                    onChange={(e) => setCustomerPhone(e.target.value)}
                                    fullWidth
                                />
                                <TextField
                                    label='Unit Price (Sale of Grave)'
                                    type='number'
                                    value={priceSaleOfGrave}
                                    onChange={(e) => setPriceSaleOfGrave(e.target.value)}
                                    fullWidth
                                />
                                <TextField
                                    label='Quantity'
                                    type='number'
                                    value={qty}
                                    onChange={(e) => setQty(e.target.value)}
                                    fullWidth
                                />
                                <TextField
                                    label='NHIL %'
                                    type='number'
                                    value={nhilPctEdit}
                                    onChange={(e) => setNhilPctEdit(e.target.value)}
                                    fullWidth
                                />
                                <TextField
                                    label='VAT %'
                                    type='number'
                                    value={vatPctEdit}
                                    onChange={(e) => setVatPctEdit(e.target.value)}
                                    fullWidth
                                />
                                <TextField
                                    label='Payment Amount'
                                    type='number'
                                    value={paymentEdited}
                                    onChange={(e) => setPaymentEdited(e.target.value)}
                                    fullWidth
                                />
                                <TextField
                                    label='VALUE ADDED TAX'
                                    type='number'
                                    value={vatAmountEdited}
                                    onChange={(e) => {
                                        setVatAmountEdited(e.target.value);
                                        setHasBeenEdited(prev => ({ ...prev, vat: true }));
                                    }}
                                    fullWidth
                                />
                                <TextField
                                    label='Ext. Price Total'
                                    type='number'
                                    value={extPriceTotalEdited}
                                    onChange={(e) => {
                                        setExtPriceTotalEdited(e.target.value);
                                        setHasBeenEdited(prev => ({ ...prev, extPrice: true }));
                                    }}
                                    fullWidth
                                />
                                <TextField
                                    label='NHIL & GET FUND LEVY'
                                    type='number'
                                    value={nhilAmountEdited}
                                    onChange={(e) => {
                                        setNhilAmountEdited(e.target.value);
                                        setHasBeenEdited(prev => ({ ...prev, nhil: true }));
                                    }}
                                    fullWidth
                                />
                                <TextField
                                    label='SUBTOTAL'
                                    type='number'
                                    value={subtotalEdited}
                                    onChange={(e) => {
                                        setSubtotalEdited(e.target.value);
                                        setHasBeenEdited(prev => ({ ...prev, subtotal: true }));
                                    }}
                                    fullWidth
                                />
                                <TextField
                                    label='DISCOUNT Amount'
                                    type='number'
                                    value={discountAmountEdited}
                                    onChange={(e) => {
                                        setDiscountAmountEdited(e.target.value);
                                        setHasBeenEdited(prev => ({ ...prev, discount: true }));
                                    }}
                                    fullWidth
                                />
                                <TextField
                                    label='TOTAL'
                                    type='number'
                                    value={totalEdited}
                                    onChange={(e) => {
                                        setTotalEdited(e.target.value);
                                        setHasBeenEdited(prev => ({ ...prev, total: true }));
                                    }}
                                    fullWidth
                                />
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label='Interment Date'
                                        value={intermentDate}
                                        onChange={(d) => setIntermentDate(d)}
                                        renderInput={(params) => <TextField fullWidth {...params} />}
                                    />
                                </LocalizationProvider>
                                <TextField
                                    label='Bed / Site'
                                    value={bedName || BedData?.bedname || ''}
                                    onChange={(e) => setBedName(e.target.value)}
                                    fullWidth
                                />
                                <TextField
                                    label='Deceased Name'
                                    value={deceasedName || `${DeceasedData?.fname || ''} ${DeceasedData?.lname || ''}`}
                                    onChange={(e) => setDeceasedName(e.target.value)}
                                    fullWidth
                                />
                                <TextField
                                    label='Payment Method'
                                    value={paymentMethod}
                                    onChange={(e) => setPaymentMethod(e.target.value)}
                                    fullWidth
                                />
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label='Payment Date'
                                        value={paymentDate}
                                        onChange={(d) => setPaymentDate(d)}
                                        renderInput={(params) => <TextField fullWidth {...params} />}
                                    />
                                </LocalizationProvider>
                            </div>
                        </Paper>
                    )}

                    <Paper elevation={3}
                        className=" bg-white  mt-8 p-5"
                        style={{ borderRadius: 20 }}>
                        <div className=" py-8">
                            <Stepper
                                activeStep={activeStep}
                                nonLinear
                            >
                                {steps.map((label) => (
                                    <Step key={label}>
                                        <StepLabel
                                            style={{
                                                color: "#A4A8AD",
                                                fontSize: 20,
                                                fontFamily: "'Poppins', sans-serif",
                                            }}
                                        >
                                            {label}
                                        </StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </div>
                        {activeStep === 0 && (
                            <>
                            <div id="printableContent">
                                        <div className=" flex justify-between ">
                                            <h1 className=" font-bold">Quote Date: {dayjs(invoiceDate).format('MMMM DD, YYYY')}<span></span></h1>
                                            <div>
                                                <h1 className="font-bold text-xl">GRACELAND MEMORIAL GARDEN</h1>
                                                <h1 className="text-center font-bold text-xl">(Berekuso)</h1>
                                                <h1 className="text-center font-bold">BEREKUSO, GHANA</h1>
                                                <h1 className="text-center font-bold">Email:<span>info@armadillogh.com</span></h1>
                                                <h1 className="text-center font-bold">Website:<span>www.armadillogh.com</span></h1>
                                            </div>
                                            <h1 className=" font-bold">Quote #: <span>{quoteNo || `Q00${random5DigitNumber}`}</span></h1>
                                        </div>
                                        <div className=" mt-4 py-2" style={{ border: "2px solid #000000", width: "40%" }}>
                                            <h1 className=" pl-1 font-bold uppercase">Customer Information</h1>
                                        </div>
                                        <div className=" flex space-x-3 ">
                                            <div className="p-1" style={{ borderBottom: "2px solid #000000", borderLeft: "2px solid #000000", borderRight: "2px solid #000000", width: "40%" }}>
                                                <h1 className="font-bold uppercase">{customerName || `${ClientData?.fname} ${ClientData?.lname}`}</h1>
                                                <h1 className=" font-bold uppercase">{customerAddress || ClientData?.daddress}</h1>
                                                <h1 className=" font-bold uppercase">{customerPhone || (ClientData?.phone ? `0${ClientData?.phone}` : '')}</h1>
                                                <h1>GHANA</h1>
                                            </div>
                                            <h1 className=" font-bold text-xl">Sales Invoice</h1>
                                        </div>
                                        <div style={{ border: "2px solid #000000" }} className=" grid grid-cols-10 mt-4">
                                            <div className=" col-span-6 py-2">
                                                <h1 className=" text-center font-bold">SALE OF A GRAVE</h1>
                                            </div>
                                            <div style={{ borderLeft: "2px solid #000000" }} className=" col-span-4">
                                                <h1 className=" text-center font-bold">Place Information</h1>
                                            </div>
                                        </div>
                                        <div style={{ border: "2px solid #000000" }} className=" grid grid-cols-10 ">
                                            <div className=" col-span-3 py-2">
                                                <h1 className="font-bold pl-2">Product Description</h1>
                                            </div>
                                            <div style={{ borderLeft: "2px solid #000000" }} className=" col-span-5 py-2">
                                                <div className=" grid grid-cols-3 pl-3">
                                                    <div>
                                                        <h1 className=" font-bold">Unit Price/Disc Price</h1>
                                                    </div>
                                                    <div>
                                                        <h1 className=" text-center  font-bold">Qty</h1>
                                                    </div>
                                                    <div>
                                                        <h1 className="font-bold">Ext. Price</h1>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ borderLeft: "2px solid #000000" }} className=" col-span-2 py-2">
                                                <h1 className="font-bold pl-2">Total Price</h1>
                                            </div>
                                        </div>
                                        <div className=" grid grid-cols-10  mb-4">
                                            <div className=" col-span-3 py-2">
                                                <h1 className="font-bold pl-2 ">{`${productLabel || productData?.sale_of_grave} GRAVE`}</h1>
                                                <div className=" pl-5 font-bold">
                                                    <h1 className=" text-sm font-bold">Transfer Information</h1>
                                                    <h1 className=" text-sm font-bold">Transfer Site(s)</h1>
                                                    <h1 className=" font-bold">{BedData?.bed}</h1>
                                                    <h1 className=" font-bold">Right Holder Information</h1>
                                                    <h1 className=" font-bold">{customerName || `${ClientData?.fname} ${ClientData?.lname}`}</h1>
                                                </div>
                                            </div>
                                            <div className=" col-span-5">
                                                <div className=" grid grid-cols-3 pl-3 pt-2">
                                                    <div>
                                                        <h1 className=" font-bold">{`GH₵ ${parseFloat(priceSaleOfGrave || Get_All_Fees || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</h1>
                                                    </div>
                                                    <div>
                                                        <h1 className=" text-center font-bold">{qty}</h1>
                                                    </div>
                                                    <div>
                                                        <h1 className=" font-bold">{`GH₵ ${effectiveExtPriceTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</h1>
                                                    </div>
                                                </div>
                                                <div className=" grid grid-cols-1 p-2">
                                                    <div className=" flex items-center space-x-14 pl-7">
                                                        <h1 className=" font-bold">VALUE ADDED TAX</h1>
                                                        <h1 className=" font-bold">{`GH₵ ${effectiveVatAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</h1>
                                                    </div>
                                                    
                                                    <div className=" flex items-center  space-x-14 pl-7">
                                                        <h1 className=" font-bold">NHIL & GET FUND LEVY</h1>
                                                        <h1 className=" font-bold">{`GH₵ ${effectiveNhilAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</h1>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className=" col-span-2">
                                            </div>
                                        </div>

                                        <div className=" flex justify-end">
                                            <h1 className=" font-bold">{`GH₵ ${Total_Combination_of_Tax1.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</h1>
                                        </div>
                                        <div className=" mb-5" style={{ borderTop: "2px solid #000000" }}>
                                        </div>

                                        {/* <div style={{ border: "2px solid #000000" }} className=" grid grid-cols-10 mt-4">
                                        <div className=" col-span-6 py-2">
                                            <h1 className=" text-center font-bold">LOWERING DEVICE/CANOPY /PLAQUE</h1>
                                        </div>
                                        <div style={{ borderLeft: "2px solid #000000" }} className=" col-span-4">
                                            <h1 className=" text-center font-bold">Place Information</h1>
                                        </div>
                                    </div> */}
                                        {/* <div style={{ border: "2px solid #000000" }} className=" grid grid-cols-10 ">
                                        <div className=" col-span-3 py-2">
                                            <h1 className="font-bold pl-2">Product Description</h1>
                                        </div>
                                        <div style={{ borderLeft: "2px solid #000000" }} className=" col-span-5 py-2">
                                            <div className=" grid grid-cols-3 pl-3">
                                                <div>
                                                    <h1 className=" font-bold">Unit Price/Disc Price</h1>
                                                </div>
                                                <div>
                                                    <h1 className=" text-center  font-bold">Qty</h1>
                                                </div>
                                                <div>
                                                    <h1 className="font-bold">Ext. Price</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div style={{ borderLeft: "2px solid #000000" }} className=" col-span-2 py-2">
                                            <h1 className="font-bold pl-2">Total Price</h1>
                                        </div>
                                    </div> */}
                                        {/* <div className=" grid grid-cols-10 ">
                                        <div className=" col-span-3 py-2">
                                            <h1 className="font-bold pl-2">LOWERING DEVICE WITHOUT NHIL/GET FUND LEVY</h1>
                                        </div>
                                        <div className=" col-span-5">
                                            <div className=" grid grid-cols-3 pl-3 pt-2">
                                                <div>
                                                    <h1 className=" font-bold">{`GHS ${Get_Lowering_Device.Lowering_Device.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</h1>
                                                </div>
                                                <div>
                                                    <h1 className=" text-center font-bold">1</h1>
                                                </div>
                                                <div>
                                                    <h1 className=" font-bold">{`GHS ${Get_Lowering_Device.Lowering_Device.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</h1>
                                                </div>
                                            </div>
                                            <div className=" grid grid-cols-1 py-2">
                                                <div className=" flex items-center space-x-8 pl-7">
                                                    <h1 className=" font-bold">VALUE ADDED TAX</h1>
                                                    <h1 className=" font-bold">{`GHS ${resultLOWERING_DEVICE.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</h1>
                                                </div>
                                                <div className=" flex items-center space-x-8 pl-7">
                                                    <h1 className=" font-bold">NHIL & GET FUND LEVY</h1>
                                                    <h1 className=" font-bold">{`GHS ${result_amount_NHIL_LOWERING_device.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div className=" col-span-2">
                                        </div>
                                    </div> */}
                                        {/* <div className=" flex justify-end">
                                        <h1 className=" font-bold">{`GHS ${Total_Combination_of_Tax2.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</h1>
                                    </div> */}
                                        {/* <div className=" mb-11" style={{ borderTop: "2px solid #000000" }}>
                                    </div> */}

                                        {/* <div style={{ border: "2px solid #000000" }} className=" grid grid-cols-10 mt-4">
                                        <div className=" col-span-6 py-2">
                                            <h1 className=" text-center font-bold">OPEN AND CLOSING</h1>
                                        </div>
                                        <div style={{ borderLeft: "2px solid #000000" }} className=" col-span-4">
                                            <h1 className=" text-center font-bold">Place Information</h1>
                                        </div>
                                    </div> */}
                                        {/* <div style={{ border: "2px solid #000000" }} className=" grid grid-cols-10 ">
                                        <div className=" col-span-3 py-2">
                                            <h1 className="font-bold pl-2">Product Description</h1>
                                        </div>
                                        <div style={{ borderLeft: "2px solid #000000" }} className=" col-span-5 py-2">
                                            <div className=" grid grid-cols-3 pl-3">
                                                <div>
                                                    <h1 className=" font-bold">Unit Price/Disc Price</h1>
                                                </div>
                                                <div>
                                                    <h1 className=" text-center  font-bold">Qty</h1>
                                                </div>
                                                <div>
                                                    <h1 className="font-bold">Ext. Price</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div style={{ borderLeft: "2px solid #000000" }} className=" col-span-2 py-2">
                                            <h1 className="font-bold pl-2">Total Price</h1>
                                        </div>
                                    </div> */}
                                        <div className=" grid grid-cols-10 ">
                                            <div className=" col-span-3 py-2">
                                                {/* <h1 className="font-bold pl-2">{` ${productData?.open_and_closing}WITHOUT NHIL/GET FUND LEVY`}</h1> */}
                                                <div className=" pl-5">
                                                    <h1 className=" text-base font-semibold">Interment Information</h1>

                                                    <h1 className=" text-base font-semibold">Date of Interment :  {intermentDate ? dayjs(intermentDate).format('MMMM DD, YYYY') : dayjs(DeceasedData?.dobrial).format('MMMM DD, YYYY')} </h1>
                                                    <h1 className=" text-base font-semibold">Interment Site(s) : {bedName || BedData?.bedname}</h1>
                                                    <h1 className=" font-bold">Deceased Information</h1>
                                                    <h1 className=" font-bold">{deceasedName || `${DeceasedData?.fname} ${DeceasedData?.lname}`}</h1>
                                                    <h1 className=" font-bold">{`Age: ${DeceasedData?.aged} years`}</h1>
                                                    <h1 className="font-bold">{`Date of Death: ${dayjs(DeceasedData?.dod).format('MMMM DD, YYYY')}`}</h1>
                                                </div>
                                            </div>
                                            <div className=" col-span-5">
                                                <div className=" grid grid-cols-3 pl-3 pt-2">
                                                    <div>
                                                        <h1>{Get_Open_closing}</h1>
                                                    </div>
                                                    {/* <div>
                                                    <h1 className=" text-center">1</h1>
                                                </div> */}
                                                    <div>
                                                        <h1>{Get_Open_closing}</h1>
                                                    </div>
                                                </div>
                                                <div className=" grid grid-cols-1">
                                                    {/* <div className=" flex items-center space-x-8 pl-7">
                                                    <h1>VALUE ADDED TAX</h1>
                                                    <h1>{`GHS ${resultOPEN_CLOSING}`}</h1>
                                                </div> */}
                                                    {/* <div className=" flex items-center space-x-8 pl-7">
                                                    <h1>NHIL & GET FUND LEVY</h1>
                                                    <h1>{`GHS ${result_amount_NHIL_OPEN_CLOSING}`}</h1>
                                                </div> */}
                                                </div>
                                            </div>
                                            <div className=" col-span-2">
                                            </div>
                                        </div>

                                        {/* <div className=" flex justify-end">
                                        <h1>{`GHS ${Total_Combination_of_Tax3}`}</h1>
                                    </div> */}
                                        <div className=" mb-6" style={{ borderTop: "2px solid #000000" }}>
                                        </div>

                                        <div className=" flex justify-end">
                                            <div className=" mt-5 space-y-5">
                                                <div className=" py-1 px-2" style={{ border: "2px solid #000000" }}>
                                                    <h1 className=" font-bold">VALUE ADDED TAX: <span className="p-1" >{`GH₵ ${effectiveVatAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</span></h1>
                                                </div>
                                                <div className=" py-1 px-2" style={{ border: "2px solid #000000" }}>
                                                    <h1 className=" font-bold">Ext. Price Total: <span className="p-1" >{`GH₵ ${effectiveExtPriceTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</span></h1>
                                                </div>
                                                <div className=" py-1 px-2" style={{ border: "2px solid #000000" }}>
                                                    <h1 className=" font-bold">NHIL & GET FUND LEVY: <span className="p-1">{`GH₵ ${effectiveNhilAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</span></h1>
                                                </div>
                                                <div className=" py-1 px-2" style={{ border: "2px solid #000000" }}>
                                                    <h1 className=" font-bold">SUBTOTAL: <span className="p-1">{`GH₵ ${effectiveSubtotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</span></h1>
                                                </div>
                                                <div className=" py-1 px-2" style={{ border: "2px solid #000000", backgroundColor: "#f0f8ff" }}>
                                                    <h1 className=" font-bold">DISCOUNT ({discountPercentage}%): <span className="p-1" style={{ color: "#22C55E" }}>{`GH₵ ${effectiveDiscountAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</span></h1>
                                                </div>
                                                <div className=" py-1 px-2" style={{ border: "2px solid #000000", backgroundColor: "#f0f8ff" }}>
                                                    <h1 className=" font-bold">TOTAL: <span className="p-1" style={{ color: "#0F1D48", fontWeight: "bold" }}>{`GH₵ ${effectiveTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</span></h1>
                                                </div>
                                            </div>
                                        </div>

                                        <div className=" mt-4">
                                            <h1 className=" font-bold underline">Payments(s)</h1>
                                            <div className=" grid grid-cols-5">
                                                <div>
                                                    <h1 className=" font-bold">Payment Date</h1>
                                                    <h1 className=" pl-4">{dayjs(paymentDate).format('MMMM DD, YYYY')}</h1>
                                                </div>
                                                <div>
                                                    <h1 className=" font-bold">Receipt Number</h1>
                                                    <h1 className=" pl-4">{receiptNo || `RC${random5DigitNumber}`}</h1>
                                                </div>

                                                <div>
                                                    <h1 className=" font-bold">Payment Method </h1>
                                                    <h1 className=" pl-4">{paymentMethod}</h1>
                                                </div>
                                                <div>
                                                    <h1 className=" font-bold">Payment Amount</h1>
                                                    <h1 className=" pl-4 font-semibold">
                                                        {`₵ ${Number(paymentEdited || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                                                    </h1>
                                                </div>
                                                <div>
                                                    <div className="">
                                                        <h1 className=" font-bold">Paid By</h1>
                                                        <h1>{customerName || `${ClientData?.fname} ${ClientData?.lname}`}</h1>
                                                    </div>
                                                    <div className=" py-2 space-y-2">
                                                        <div className=" flex items-center justify-between">
                                                            <h1 className=" font-bold">Total Paid: </h1>
                                                            <h1 className=" font-bold">
                                                                {`₵ ${Number(paymentEdited || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                                                            </h1>
                                                        </div>

                                                        <div className=" flex items-center justify-between">
                                                            <h1 className=" font-bold">Balance Owing</h1>
                                                            <h1 className=" font-bold">{`₵ ${AmountLeft?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</h1>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                            </div>
                            <div className=" flex justify-end py-4">
                                <Button 
                                    variant="contained" 
                                    style={{ backgroundColor: "#083050", color: "white", paddingLeft: 13, paddingRight: 13 }} 
                                    onClick={() => {
                                        toast.success('Invoice created successfully!', {
                                            position: toast.POSITION.TOP_CENTER
                                        });
                                        setActiveStep(1);
                                    }}
                                >
                                    Next
                                </Button>
                            </div>
                            </>
                        )}

                        {activeStep === 1 && (
                            <>
                            <div className=" mt-9" id="printableContent">
                                <h1 className=" font-bold">{`No:T000${random5DigitNumber}`}</h1>
                                <div>
                                    <h1 className=" text-center text-xl font-bold">GRACELAND MEMORIAL GRADEN (Berekuso)</h1>
                                    <h1 className=" font-bold text-center">P.O BOX 14322</h1>
                                    <h1 className=" font-bold text-center">BEREKUSO</h1>
                                </div>

                                <div>
                                    <h1 className=" font-bold text-3xl text-center py-4"> Interment Rights Certificate</h1>
                                </div>

                                <div className=" space-y-3 pt-2">
                                    <h1 className=" font-bold">This indenture, made on <span>{formattedDate}</span></h1>
                                    <h1 className=" font-bold">Between: <span>GRACELAND MEMORIAL GARDEN (Berekuso)</span></h1>
                                </div>

                                <div className=" py-3">
                                    <h1 className=" font-bold">hereinafter called the Lessor, of the first part, and:</h1>
                                    <h1 className=" font-bold uppercase">{customerName || `${ClientData?.fname} ${ClientData?.lname}`}</h1>
                                    <h1 className=" font-bold uppercase">{customerAddress || ClientData?.daddress}</h1>
                                    <h1 className=" font-bold uppercase">{customerPhone || (ClientData?.phone ? `0${ClientData?.phone}` : '')}</h1>
                                    <h1 className=" font-bold">BEREKUSO, GHANA</h1>
                                </div>

                                <div className=" py-2">
                                    <h1 className="font-bold">herinafter called the Lessee, to include the plural should more than one names appear above, of the second part.</h1>

                                    <div className=" py-3">
                                        <h1 className="font-bold">Witness that for the sum of</h1>
                                        <div className=" pt-5 pl-4 space-y-2">
                                            <div className=" flex items-center space-x-5">
                                                <h1 className=" font-bold">Site Price</h1>
                                                <h1 className=" font-bold"> : {`GH₵ ${effectiveTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</h1>
                                            </div>
                                            <div className=" flex items-center space-x-5">
                                                <h1 className=" font-bold">VAT :</h1>
                                                <h1 className=" font-bold">{`GH₵ ${effectiveVatAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</h1>
                                            </div>
                                        </div>
                                    </div>

                                    <div className=" space-y-4 py-5">
                                        <h1 className=" text-center font-bold">The Lessor does hereby sell the Lessee, interment right in the following locations:</h1>
                                        <h1 className=" text-center font-bold">{`${bedName || BedData?.bedname} (${productData?.sale_of_grave})`}</h1>
                                    </div>
                                    <div className=" pt-8">
                                        <h1 className=" text-center font-bold">This Certificate cannot be transferred. It must be returned to Armadillo Ghana </h1>
                                        <h1 className=" text-center font-bold">Company Limited , who will issue a new certificate to the transferee</h1>
                                    </div>

                                    <div className=" flex justify-end mt-16">
                                        <div>
                                        </div>
                                        <h1 className="font-bold text-end" style={{ borderTop: "2px solid #000000", width: "30%" }}>Manager of the Cemetery</h1>
                                    </div>

                                </div>
                            </div>
                            <div className=" flex justify-between py-4">
                                <Button 
                                    variant="outlined" 
                                    style={{ borderColor: "#083050", color: "#083050", paddingLeft: 13, paddingRight: 13 }} 
                                    onClick={() => {
                                        setActiveStep(0);
                                    }}
                                >
                                    Back
                                </Button>
                                <Button 
                                    variant="contained" 
                                    style={{ backgroundColor: "#083050", color: "white", paddingLeft: 13, paddingRight: 13 }} 
                                    onClick={() => {
                                        navigate("/all-deceased");
                                    }}
                                >
                                    Done
                                </Button>
                            </div>
                            </>
                        )}
                    </Paper>






                </div>
            </div>
            <ToastContainer />
        </div >
    )
}

export default DeceasedInvoice;





